//
// locales/vanilla/gl.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/gl.json';
import localeData from 'react-intl/locale-data/gl.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
